module.exports = __webpack_public_path__ + "img/logo-client.dcc3e8bd.svg";